function trimAdminPath(path: string): string {
  return path.replace(/\/$/, "");
}

export function isMainAdminSettingsPath(pathname: string): boolean {
  const normalized = trimAdminPath(pathname);
  return normalized === "/admin/settings" || normalized.startsWith("/admin/settings/");
}

export function isAdminNavOptionActive(currentUrl: string, optionUrl: string | undefined): boolean {
  if (!optionUrl) {
    return false;
  }

  const normalizedCurrent = trimAdminPath(currentUrl);
  const normalizedOption = trimAdminPath(optionUrl);

  return (
    normalizedCurrent === normalizedOption ||
    normalizedCurrent.startsWith(`${normalizedOption}/`)
  );
}
